@if(showIndication()){
<mat-chip
  disableRipple="true"
  class="text-xs orange-chip p-0"
  matTooltip="Johnston's Connected Trade Indication represents the level that Connected projects the market will trade at"
  aria-label="Button that displays a tooltip when focused or hovered over"
  >JCTI
</mat-chip>
}
